import {
  NavigationEvents,
  trackGoldStandardEvent,
  getPageSource,
} from '@mc/track-event'

import { BOGO_PROPS } from '../../lib/constants'

type Location = typeof BOGO_PROPS.PROMO_BANNER.LOCATION

export const trackBogoNavigationClicked = ({
  action,
  location,
}: {
  action: string
  location: Location
}) => {
  trackGoldStandardEvent(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    location,
    action,
    page_source: getPageSource(),
  })
}
